$( document ).ready(function() { 

  try {
    if ($('.product-image-slider .product-media-parent').length > 1) {
      var productImageSlider = new Swiper('.product-image-slider', {
        loop: true,
        navigation: {
          nextEl: '.image-slider-next',
          prevEl: '.image-slider-prev',
        },
      });
    }
  } catch (exception) {
    console.log('Product Images Slider Error on the Product Page: ' + exception);
  }

  $(document).on('click', '.quantity-selector-plus-button', function () {
    $('.quantity-selector-number').val(parseInt($('.quantity-selector-number').val()) + 1);
  })

  $(document).on('click', '.quantity-selector-minus-button', function () {
    if (parseInt($('.quantity-selector-number').val()) > 1) {
      $('.quantity-selector-number').val(parseInt($('.quantity-selector-number').val()) - 1);
    } else {
      $('.quantity-selector-number').val(1);
    }
  });
});